import type { ColumnFiltersState } from '@tanstack/react-table';
import type { DivisionOrdersSearchParams } from './atoms';

export const DEFAULT_PARAMS: DivisionOrdersSearchParams = {
  page: 1,
  pageSize: 100,
  sortAttribute: 'createdAt',
  sortDirection: 'DESC',
};

export const SORT_FIELD_MAP: Record<string, string> = {
  name: 'name',
  source: 'source',
  lineItemCount: 'lineItemCount',
  dateReceived: 'dateReceived',
  dateConfirmed: 'dateConfirmed',
  dateReturned: 'dateReturned',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  operatorName: 'operatorName',
  accountName: 'accountName',
  createdByName: 'createdByName',
};

// Column-level filter UIs aren't used (filters live in the side panel).
// This callback stays a no-op so the DataTable can still wire onFilterChange
// without affecting our params.
export const columnFiltersToParams = (
  _filters: ColumnFiltersState
): Partial<DivisionOrdersSearchParams> => ({});
